module.exports = __webpack_public_path__ + "static/media/16UNODC14.c98dc98f.jpg";